import axios from 'axios';
import qs from 'qs';

import { resetCookie } from '@src/utils/pendingInitInfo';
import messageCom from '@src/utils/messageCom';

// 默认请求头
const defaultRequestHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

const ins = axios.create({
  baseURL: '/api',
  headers: defaultRequestHeaders,
  withCredentials: true,
  timeout: 600000, // 10min
});

// 请求拦截
ins.interceptors.request.use((config) => {
  // 请求头芯智能参数用作区分Operator Customer平台
  config.headers.portal = 'operator';

  return config;
}, (error) => {
  return Promise.reject(error);
});

// // 响应拦截
// ins.interceptors.response.use((response) => {
//   return response;
// }, (error) => {
//   return Promise.reject(error);
// });

// 记录请求取消方法
const InitiatedRequest = {}

/**
 * @param {String} url - 接口地址
 * @param {Objech} data - 请求参数
 * @param {String} propsType - 'custom' or null - 是否自定义传参格式
 * @param {Boolean} cancelOff - 部分特殊场景请求不需要做校验取消上一次请求 true-取消  false-不取消
 * @param {Boolean} Interface - 部分接口不需要统一处理返回信息是否报错，原样返回接口返参
 * @param {object} headers - 请求头，对于部分接口请求头类型不同
 */
const request = async ({
  url = '',
  data = {},
  method = 'get',
  propsType = '',
  cancelOff = false,
  Interface = false,
  headers = defaultRequestHeaders
}) => {
  // 只有get请求才需要取消上一次请求
  if (method !== 'get') cancelOff = true;

  const requestIns = () => {
    // url基础参数
    const basicParams = {
      sign: process.env.SIGN,
      appid: process.env.APPID,
      timestamp: process.env.TIMESTAMP,
    };

    let configUrl = url.split('?').length > 1 ? `${url}` : `${url}`;

    // 取消上一次相同的请求
    if (!cancelOff && InitiatedRequest[url + method]) {
      InitiatedRequest[url + method].cancel('cancel request');

      InitiatedRequest[url + method] = undefined;
      delete InitiatedRequest[url + method];
    }

    InitiatedRequest[url + method] = axios.CancelToken.source();

    switch (method.toLocaleUpperCase()) {
      case 'GET':
        return ins.get(configUrl, {
          params: data,
          cancelToken: InitiatedRequest[url + method].token,
          headers: headers
        });
      case 'POST':
        if (propsType === 'custom') {
          return ins.post(configUrl,
            data,
            {
              cancelToken: InitiatedRequest[url + method].token,
              headers,
            }
          );
        }

        return ins.post(configUrl, qs.stringify(data), { cancelToken: InitiatedRequest[url + method].token, headers });
      case 'PUT':
        if (propsType === 'custom') {
          return ins.put(configUrl, data, { cancelToken: InitiatedRequest[url + method].token, headers });
        }

        return ins.put(configUrl, qs.stringify(data), { cancelToken: InitiatedRequest[url + method].token, headers });
      case 'DELETE':
        if (propsType === 'custom') {
          return ins.delete(configUrl,
            {
              data,
              cancelToken: InitiatedRequest[url + method].token,
              headers
            });
        }

        return ins.delete(configUrl,
          {
            data: qs.stringify(data),
            cancelToken: InitiatedRequest[url + method].token,
            headers
          });
      default:
        return ins.get(configUrl, {
          params: data,
          cancelToken: InitiatedRequest[url + method].token,
          headers
        });
    }
  };

  try {
    const { data } = await requestIns();
    
    (InitiatedRequest)[url + method] = '';
    // 未登录
    if (data.status === 4010) {
      throw Error('Please login again');
    }

    if (Interface) {
      return data
    }

    // 接口其他错误
    if((data.status >= 1) && (data.status <= 3)){
      messageCom.warning(data?.message || '');
      
      return false;
    }else if (data.status >= 4) {
      throw Error(data.message);
    }

    let newData = data.data || data;

    // if(!newData?.status){
    //   newData.status = data.status || 0;
    // }

    // if(!newData?.message){
    //   newData.message = data.message || '';
    // }

    return newData;

  } catch (error) {
    // 未登录
    if (error.message === 'Please login again') {
      messageCom.warning(error?.message || '');
      // localStorage.removeItem('operatorU');
      // localStorage.removeItem('operatorP');

      // 延迟跳转，如直接跳转会导致未登录提示框一闪而过
      setTimeout(() => {
        window.location.replace('/login');
        resetCookie();
      }, 600);

      return false;
    }

    if (error.message === 'cancel request') {
      return 'cancel';
    }

    // 接口其他错误
    messageCom.error(error?.message || '');

    return false;
  } finally { }
};

export default request;
